import { makeStyles } from "@material-ui/core/styles";
import { secondary } from "../../../assets/variables.module.scss";

const useStyles = makeStyles(() => ({
  checkbox: {
    "&:hover": { backgroundColor: "transparent" },
    "& svg": {
      color: secondary,
    },
  },
}));

export default useStyles;
